
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
  },
  watch: {
    $route: {
      handler: async function(to, from) {
        await (this as any).init();
      },
    },
  },
})
export default class SelectRequests extends Vue {
  dictionary: any = {};
  title: string = "";
  filter: any = {
    requestNumber: "",
    policy_number: "",
  };
  requests: any = [];
  statuses: any = [];
  limit: number = 5;
  totalRows: number = 0;
  currentSort: Record<string, string> = {
    col: "requests.id",
    dir: "desc",
  };

  async mounted() {
    await this.loadDictionary();
    await this.init();
  }

  async init() {
    this.title = "Declarar Siniestro";
    await this.loadStatuses();
    await (this as any).loadRequests(1, this.currentSort);
  }

  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    return "inactive";
  }

  async onPageChange(page: number, limit: number) {
    this.limit = limit;
    await (this as any).loadRequests(page, this.currentSort);
  }

  async loadRequests(page: number, sort: Record<string, string>) {
    this.currentSort = sort;
    this.filter.status = this.statuses.indexOf("Procesada");
    this.filter.companyId = this.$store.state.companyId;

    const response: any = await (this.$root as any)._post("requests/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      models: "companies",
      ...this.filter,
    });

    this.totalRows = response.totalRows;
    this.requests = response.data;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  nextStep(requestId: number) {
    this.$store.commit("setNewClaimRequest", requestId);
    this.$router.push("/claims/new-claim/fill-claim-data");
  }
}
